import { render, staticRenderFns } from "./FactorDisplay.vue?vue&type=template&id=f6af6978&scoped=true&"
import script from "./FactorDisplay.vue?vue&type=script&lang=ts&"
export * from "./FactorDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6af6978",
  null
  
)

export default component.exports